import { useUiPreferences } from '../../../hooks'
import { ServerApiVersion } from '../types'

export const useServerApiVersion = () => {
  const { uiPreferences, updateUiPreferences } = useUiPreferences()

  const setServerApiVersion = (version: ServerApiVersion) => {
    updateUiPreferences({ serverApiVersion: version })
  }

  return {
    serverApiVersion: uiPreferences.serverApiVersion ?? ServerApiVersion.V4,
    setServerApiVersion,
  }
}
